import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";

const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 80vh;
  padding: 20px;
  background-color: #f5f5f5;
`;

const Header = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Logo = styled.img`
  width: 150px;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #333;
  margin-top: 20px;
`;

const Main = styled.main`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
`;

const Description = styled.p`
  font-size: 1.2rem;
  color: #666;
`;

export const Dashboard = () => {
  const companyLogo = useSelector(
    (state) => state?.authenticationSlice?.companyLogo
  );

  const companyName = useSelector(
    (state) => state?.authenticationSlice?.companyName
  );

  console.log("companyLogo", companyLogo);

  return (
    <DashboardContainer>
      <Header>
        <Logo src={`data:image/png;base64,${companyLogo}`} />
        <Title>{companyName}</Title>
      </Header>

      <Main>
        <Description>
          This system enables to track gate entry and exit of the passengers.
        </Description>
      </Main>
    </DashboardContainer>
  );
};
